import { render } from "./HomePaperCenter.vue?vue&type=template&id=7f8880a3&scoped=true"
import script from "./HomePaperCenter.vue?vue&type=script&lang=js"
export * from "./HomePaperCenter.vue?vue&type=script&lang=js"

import "./HomePaperCenter.vue?vue&type=style&index=0&id=7f8880a3&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8880a3"]])

export default __exports__